"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftSearchResultsCountDto = instanceOfShiftSearchResultsCountDto;
exports.ShiftSearchResultsCountDtoFromJSON = ShiftSearchResultsCountDtoFromJSON;
exports.ShiftSearchResultsCountDtoFromJSONTyped = ShiftSearchResultsCountDtoFromJSONTyped;
exports.ShiftSearchResultsCountDtoToJSON = ShiftSearchResultsCountDtoToJSON;
exports.ShiftSearchResultsCountDtoToJSONTyped = ShiftSearchResultsCountDtoToJSONTyped;
const CountByDate_1 = require("./CountByDate");
/**
 * Check if a given object implements the ShiftSearchResultsCountDto interface.
 */
function instanceOfShiftSearchResultsCountDto(value) {
    if (!('totalCount' in value) || value['totalCount'] === undefined)
        return false;
    if (!('countsByDate' in value) || value['countsByDate'] === undefined)
        return false;
    return true;
}
function ShiftSearchResultsCountDtoFromJSON(json) {
    return ShiftSearchResultsCountDtoFromJSONTyped(json, false);
}
function ShiftSearchResultsCountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalCount': json['totalCount'],
        'countsByDate': (json['countsByDate'].map(CountByDate_1.CountByDateFromJSON)),
    };
}
function ShiftSearchResultsCountDtoToJSON(json) {
    return ShiftSearchResultsCountDtoToJSONTyped(json, false);
}
function ShiftSearchResultsCountDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'totalCount': value['totalCount'],
        'countsByDate': (value['countsByDate'].map(CountByDate_1.CountByDateToJSON)),
    };
}
//# sourceMappingURL=ShiftSearchResultsCountDto.js.map